export default __webpack_public_path__ + "static/media/project-wizard-milestones_dark.2bbfbf43.png";